module.exports = __webpack_public_path__ + "img/post_offer_fail.2e1e808a.png";